import { createReactBlockSpec } from "@blocknote/react";
import { useContext, useState } from "react";
import { Colors } from "schemas";
import { BlocksContext } from "../../BlocksContext";
import { LinkButton } from "../../components/LinkButton";
import { PageLinkBlock } from "./PageLinkBlock";

export const PageBlockSpec = createReactBlockSpec(
  {
    type: "pageBlock",
    propSchema: {
      pageId: {
        default: "",
      },
      label: {
        default: "",
      },
      url: {
        default: "",
      },
      buttonTextColor: {
        default: "",
      },
      buttonBackgroundColor: {
        default: "",
      },
      buttonTextAlignment: {
        values: ["Center", "Default"],
        default: "Default",
      },
      buttonBorderRadius: {
        values: ["Rounded", "Smooth", "Square"],
        default: "",
      },
    },
    content: "none", // No editable content needed
    isSelectable: true,
  },
  {
    render: ({
      editor,
      block: {
        id,
        props: { pageId, label, buttonTextColor, buttonBackgroundColor, buttonBorderRadius, buttonTextAlignment },
      },
    }) => {
      const { PageBlockDrawer, onPageEdit } = useContext(BlocksContext);
      const [showDrawer, setShowDrawer] = useState(!pageId);

      const handleCloseDrawer = () => {
        // If the user closes the drawer without creating a page,
        // remove the empty block
        if (!pageId) {
          editor.removeBlocks([id]);
        }
        setShowDrawer(false);
      };

      const handlePageCreated = (newPageId: string) => {
        // Update the block with the new pageId
        // biome-ignore lint/suspicious/noExplicitAny:
        editor.updateBlock(id, { props: { pageId: newPageId } as any });
        setShowDrawer(false);
      };

      // If page ID is empty, show the drawer to create a page
      if (showDrawer) {
        return <PageBlockDrawer onClose={handleCloseDrawer} onPageCreated={handlePageCreated} />;
      }

      return (
        <PageLinkBlock
          label={label}
          buttonTextColor={buttonTextColor}
          buttonBackgroundColor={buttonBackgroundColor}
          buttonBorderRadius={buttonBorderRadius}
          buttonTextAlignment={buttonTextAlignment}
          onEdit={() => {
            onPageEdit(pageId);
          }}
        />
      );
    },
    toExternalHTML: ({ block }) => {
      const { label, url, buttonTextColor, buttonBackgroundColor, buttonBorderRadius, buttonTextAlignment } =
        block.props;
      const PageIconLight =
        "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/574e1f21-32d4-4dc3-4aa8-ef2389974c00/logo";
      const PageIconDark = "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/168965c4-5d02-42f1-5a5a-dfe55e2b9b00/logo";
      const iconSrc = buttonTextColor === Colors.Neutral0 ? PageIconLight : PageIconDark;

      return (
        <LinkButton
          href={url}
          iconSrc={iconSrc}
          buttonTextColor={buttonTextColor}
          buttonBackgroundColor={buttonBackgroundColor}
          buttonBorderRadius={buttonBorderRadius}
          buttonTextAlignment={buttonTextAlignment}
        >
          <div
            style={{
              display: "inline-block",
              width: buttonTextAlignment === "Center" ? "auto" : "90%",
            }}
          >
            {label}
          </div>
        </LinkButton>
      );
    },
  },
);
